var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-checkbox',{attrs:{"disabled":!_vm.hasPermission('life.admin.roles.edit'),"color":"primary"},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }